import { BaseRequest } from './base.request';

export class VerifyCodeRequest extends BaseRequest {
  public codigo: string;
}
